import React, { FC, memo, useCallback, useState } from 'react'
import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'
import { HeadsetVariant } from './HeadsetVariant'
import { getHeadsetVariantInfo, HeadsetVariantType } from '../utils'
import { staticMultimedia } from 'utils'

import styles from './styles.module.scss'


interface IProps {
}

const KnowSection: FC<IProps> = props => {


  return (
    <SectionContainer withBackgroundImage>
      <InnerContainer>
        <div className={styles.knowContainer}
             style={{backgroundImage: `url(${staticMultimedia.knowTheDifferentVR1Variants})`}}
        >
          <TitleSection title={'Get to know the main VR1 variants:'}
                        subTitle={'Choose from the 4 main variants, or mix and match any combination of those modules'}/>
          <div className={styles.VR1Variants}>
            <div className={styles.variantsInner}>
              <HeadsetVariant variant={getHeadsetVariantInfo(HeadsetVariantType.VR_Headset)}/>
              <HeadsetVariant variant={getHeadsetVariantInfo(HeadsetVariantType.Eye_Tracking)}/>
            </div>
            <div className={styles.variantsInner}>
              <HeadsetVariant variant={getHeadsetVariantInfo(HeadsetVariantType.Hand_Tracking)}/>
              <HeadsetVariant variant={getHeadsetVariantInfo(HeadsetVariantType.MR_Cameras)}/>
            </div>
          </div>
        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(KnowSection)
